import { render, staticRenderFns } from "./riskHazardPop.vue?vue&type=template&id=1fbee0b2"
import script from "./riskHazardPop.vue?vue&type=script&lang=js"
export * from "./riskHazardPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fbee0b2')) {
      api.createRecord('1fbee0b2', component.options)
    } else {
      api.reload('1fbee0b2', component.options)
    }
    module.hot.accept("./riskHazardPop.vue?vue&type=template&id=1fbee0b2", function () {
      api.rerender('1fbee0b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/riskHazardPop.vue"
export default component.exports